export class Configuration {
  /**
   * constructor description
   * @param {Object} configuration - An object.
   * @param  {number[]} configuration.range
   * @param  {Number} configuration.cost
   * @param  {String} configuration.start_date
   * @param  {String} configuration.end_date
  */
  constructor({
    range, cost, start_date, end_date,
  }) {
    this.range = range;
    this.cost = cost;
    this.start_date = start_date;
    this.end_date = end_date;
  }

  static createEmpty() {
    const range = [1, 2];
    const cost = 1;
    const start_date = new Date().toISOString();
    const end_date = new Date().toISOString();
    return new Configuration({
      range, cost, start_date, end_date,
    });
  }
}
